import {Suspense} from 'react'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {useDevelopmentQuery} from './data/route-queries'
import styles from './Development.module.css'
import {LinkedIssues} from './LinkedIssues'
import {UserSectionSkeleton} from './UserSectionSkeleton'

export function Development() {
  return (
    <ErrorBoundary
      boundaryName="Development"
      fallback={<span className={styles.emptyState}>Unable to load development</span>}
    >
      <Suspense fallback={<UserSectionSkeleton placeholderRows={1} />}>
        <DevelopmentContent />
      </Suspense>
    </ErrorBoundary>
  )
}

function DevelopmentContent() {
  const {data} = useDevelopmentQuery()
  const {linkedIssues} = data

  return (
    <>
      <span className={styles.helpText}>Successfully merging this pull request may close these issues.</span>
      {/* TODO: Render SSO prompts here when the viewer needs to authorize SAML SSO for one or more orgs. */}
      {linkedIssues.length === 0 ? (
        <span className={styles.emptyState}>None yet</span>
      ) : (
        <LinkedIssues linkedIssues={linkedIssues} />
      )}
    </>
  )
}
